/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { VSTAToken, VSTATokenInterface } from "../VSTAToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_treasurySig",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint256",
        name: "chainID",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "treasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type VSTATokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VSTATokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VSTAToken__factory extends ContractFactory {
  constructor(...args: VSTATokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _treasurySig: string,
    overrides?: Overrides & { from?: string }
  ): Promise<VSTAToken> {
    return super.deploy(_treasurySig, overrides || {}) as Promise<VSTAToken>;
  }
  override getDeployTransaction(
    _treasurySig: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(_treasurySig, overrides || {});
  }
  override attach(address: string): VSTAToken {
    return super.attach(address) as VSTAToken;
  }
  override connect(signer: Signer): VSTAToken__factory {
    return super.connect(signer) as VSTAToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VSTATokenInterface {
    return new utils.Interface(_abi) as VSTATokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VSTAToken {
    return new Contract(address, _abi, signerOrProvider) as VSTAToken;
  }
}
